import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ShowFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ShowFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M14.5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M.35 12C2.01 6.78 6.59 3.03 12 3.03S21.99 6.78 23.65 12c-1.66 5.22-6.24 8.97-11.65 8.97S2.01 17.22.35 12Zm7.15 0c0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5S7.5 9.51 7.5 12Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ShowFilled;